import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Renew billable event DTO
 */
export class RenewBillableEventDto {
	id!: number;
	@TransformDate()
	leasedUntil?: Date;
}
